module.exports = __webpack_public_path__ + "img/title-img.dbb80900.png";